import Parse from '@/parse'
const Info = Parse.Object.extend('Info')

export default {
  initForm ({ state, commit }) {
    commit('setContent', state.info.get('content'))
  },

  resetForm ({ commit }) {
    commit('setContent', '')
  },

  retrieveInfos ({ commit }) {
    let query = new Parse.Query(Info)
    query.descending('createdAt')
    query.find().then((results) => {
      commit('setInfos', results)
    }).catch((error) => {
      console.log(error)
    })
  },

  async getInfo({ commit }, id) {
    let query = new Parse.Query(Info)
    try {
      let object = await query.get(id)
      commit('setInfo', object)
    } catch (error) {
      console.log(error)
    }
  },

  async saveInfo({ state, dispatch }, action) {
    let info = state.info
    if (action === 'new') {
      info = new Info()
      info.set('date', new Date())
    }

    info.set('content', state.content)
    try {
      await info.save()
      let snackBarInfo = 'お知らせを更新しました。'
      if (action === 'new') {
        snackBarInfo = 'お知らせを作成しました。'
      }
      return snackBarInfo
    } catch (error) {
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  deleteInfo({ state, commit }) {
    state.info.destroy().then(() => {
      commit(
        'snackBar/addMessage',
        'お知らせを削除しました。',
        { root: true }
      )
    })
  }
}
